import React, { useEffect, useState, useRef } from "react";
import styles from "./MusicPopUp.module.css";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useMusic } from "../../context/MusicContext";

/*** icon import ***/
import { FaRegCirclePlay as PlayIcon } from "react-icons/fa6";
import { FaCirclePause as PauseIcon } from "react-icons/fa6";
import { FaChevronCircleRight } from "react-icons/fa";
// import { LuArrowLeftCircle } from "react-icons/lu";
/** Play Next Icon */
import { MdOutlineSkipPrevious as PreviousIcon } from "react-icons/md";
import { MdOutlineSkipNext as NextIcon } from "react-icons/md";

import ProgressBar from "../reusable/player/ProgressBar";

const MusicPopUp = () => {
  const musicContext = useMusic();
  const [isVisible, setIsVisible] = useState(true);
  const [leftButton, setleftButton] = useState(false);

  /** this useState is use to get stop position of rotation image **/
  // const [startPosition, setStartPosition] = useState(0);
  // const [stopPosition, setStopPosition] = useState(0);
  // const containerRef = useRef();

  const navigate = useNavigate();

  const containerVariants = {
    visible: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: "120%" },
  };

  const iconVariants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };

  const handleClose = () => {
    // musicContext.setIsVisible(false);
    // musicContext.setleftButton(true);
    setIsVisible(false);
    setleftButton(true);
  };

  const handleOpen = () => {
    // musicContext.setIsVisible(true);
    // musicContext.setleftButton(false);
    setIsVisible(true);
    setleftButton(false);
  };

  const handleRedirectToMusic = () => {
    navigate(musicContext.song.route);
  };

  return (
    <div className={musicContext.isPopUpRemove && "hidden"}>
      {/* {
    musicContext.isPopUpRemove && ( */}
      <motion.div
        key={musicContext.song.id}
        className={`rounded-lg fixed z-20 bg-slate-600 w-full h-23 justify-center ${styles.bottom} flex items-center`}
        variants={containerVariants}
        initial={isVisible ? "visible" : "hidden"}
        animate={isVisible ? "visible" : "hidden"}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <div className="w-1/2 flex" onClick={handleRedirectToMusic}>
          <div className="w-1/3">
            <img
              src={musicContext.song.image}
              alt={`Image`}
              className={`rounded-full w-12 h-12 inline-block m-3 ${styles.circleImage}`}
              width={50}
              height={50}
            />
          </div>
          <div className="inline-block w-2/3 my-auto">
            <span className="block text-sm truncate pb-2">
              {musicContext.song.title}
            </span>
            <span className="block text-xs truncate py-1">
              {musicContext.song.artist}
            </span>
          </div>
        </div>
        <div className="w-1/2 flex justify-center py-2 rounded-full">
          {/* {musicContext.musicRef && <ProgressBar musicRef={musicContext.musicRef}/>}  */}
          {musicContext.musicType == "many" && (
            <button
              onClick={() => {
                if (musicContext.playlist && musicContext.currentIndex > 0) {
                  musicContext.playPreviousTrack();
                  musicContext.setIsClickSkip(false);
                }
              }}
              type="button"
              className="w-1/3 flex justify-end"
            >
              {musicContext.playlist && musicContext.currentIndex > 0 ? (
                <PreviousIcon
                  className="h-9 w-9 text-yellow-300"
                  aria-hidden="true"
                />
              ) : null}
            </button>
          )}
          <button
            onClick={musicContext.toggleAudio}
            type="button"
            className="m-auto w-9 rounded-full text-white shadow-sm"
          >
            {!musicContext.play ? (
              <PlayIcon
                className="h-9 w-9 text-yellow-300"
                aria-hidden="true"
              />
            ) : (
              <PauseIcon
                className="h-9 w-9 text-yellow-300"
                aria-hidden="true"
              />
            )}
          </button>

          {musicContext.musicType == "many" && (
            <button
              onClick={() => {
                if (
                  musicContext.playlist &&
                  musicContext.currentIndex < musicContext.playlist.length - 1
                ) {
                  musicContext.playNextTrack();
                  musicContext.setIsClickSkip(false);
                }
              }}
              type="button"
              className="w-1/3 flex items-start"
            >
              {musicContext.playlist &&
              musicContext.currentIndex < musicContext.playlist.length - 1 ? (
                <NextIcon
                  className="h-9 w-9 text-yellow-300"
                  aria-hidden="true"
                />
              ) : null}
            </button>
          )}
        </div>

        <span className="absolute top-[-10px] right-0" onClick={handleClose}>
          <FaChevronCircleRight />
        </span>
      </motion.div>

      <motion.div
        className={`absolute top-[-50px] right-2 cursor-pointer z-20 h-23  `}
        variants={iconVariants}
        initial="hidden"
        animate={leftButton ? "visible" : "hidden"}
        transition={{ duration: 0.5, ease: "easeOut" }}
        onClick={handleOpen}
      >
        {/* <LuArrowLeftCircle /> */}
      </motion.div>
    </div>
  );
};

export default MusicPopUp;
